import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Quiz from './views/Quiz.vue'
import Review from './views/Review.vue'
import Unsubscribe from './views/Unsubscribe.vue'

import UserProfile from './views/UserProfile.vue'
import UserQuiz from './views/UserQuiz.vue'
import UserSentences from './views/UserSentences.vue'
import EditUserInfo from './views/EditUserInfo.vue'
import ManageLists from './views/ManageLists.vue'

import SignUpConfirmation from './views/SignUpConfirmation.vue'
import SignIn from './views/SignIn.vue'
import SignInAnswerChallenge from './views/SignInAnswerChallenge.vue'

import { SENTENCES_ENABLED } from './featureFlags'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/quiz',
      name: 'quiz',
      component: Quiz
    },
    {
      path: '/review',
      name: 'review',
      component: Review
    },
    {
      path: '/history',
      redirect: '/review'
    },
    {
      path: '/unsub',
      name: 'unsub',
      component: Unsubscribe
    },
    {
      path: '/profile',
      name: 'user-profile',
      component: UserProfile
    },
    // Nothing links here, but the route would still resolve if typed directly.
    // Redirect to the profile while the feature is hidden.
    {
      path: '/sentences',
      name: 'user-sentences',
      ...(SENTENCES_ENABLED ? { component: UserSentences } : { redirect: '/profile' })
    },
    {
      path: '/my-quizzes',
      name: 'user-quiz',
      component: UserQuiz
    },
    {
      path: '/subscribed',
      name: 'sign-up-confirmation',
      component: SignUpConfirmation
    },
    {
      path: '/signin',
      name: 'sign-in',
      component: SignIn
    },
    {
      path: '/verification',
      name: 'answer-challenge',
      component: SignInAnswerChallenge
    },
    {
      path: '/profile-settings',
      name: 'edit-user-info',
      component: EditUserInfo
    },
    {
      path: '/manage-lists',
      name: 'manage-lists',
      component: ManageLists
    }
  ]
})
